// language.ts
import enMessages from './assets/json/languages/en.json';
import vnMessages from './assets/json/languages/vn.json';

// Khởi tạo đối tượng chứa các thông điệp cho từng ngôn ngữ
const messages: { [key: string]: any } = {
    en: enMessages,
    vn: vnMessages,
};

let currentLanguage: string = 'vn'; // Ngôn ngữ mặc định là tiếng Việt

export const setLanguage = (language: string) => {
    // normalize input
    const code = (language || '').toLowerCase().trim();

    // common alias map (accept 'vi' as 'vn')
    const alias: { [key: string]: string } = {
        vi: 'vn',
        vn: 'vn',
        en: 'en',
        'en-us': 'en',
        'en-gb': 'en',
    };

    let resolved = alias[code] || code;

    // If no explicit language provided or not found, try navigator.language
    if (!resolved && typeof navigator !== 'undefined') {
        const nav = (navigator.language || '').toLowerCase();
        if (nav.indexOf('vi') === 0) resolved = 'vn';
        else if (nav.indexOf('en') === 0) resolved = 'en';
    }

    if (messages[resolved]) {
        currentLanguage = resolved;
    } else {
        // final fallback to English
        // eslint-disable-next-line no-console
        console.warn(`Language '${language}' not found. Falling back to 'en'.`);
        currentLanguage = 'en';
    }
};

export const getMessage = (key: keyof typeof enMessages) => {
    // Try current language, fall back to English, finally return key as string
    const langMessages = messages[currentLanguage] || messages['en'];
    if (langMessages && Object.prototype.hasOwnProperty.call(langMessages, key)) {
        return langMessages[key];
    }
    // fallback to English
    if (messages['en'] && Object.prototype.hasOwnProperty.call(messages['en'], key)) {
        return messages['en'][key];
    }
    // ultimate fallback
    return String(key);
};
